module.exports = __webpack_public_path__ + "img/6.46b35a4b.jpg";